import { Order } from '~/@types/table/order';
import { apiClient } from '~/api/client';

export type ShowWithRecordsParams = {
  id: string;
  paging_params: {
    limit: PaginationLimit;
    search_after?: (string | number)[];
    reverse_sort: boolean;
  };
  sort_params: {
    field: string;
    order: Order;
  };
};

export const showWithRecords = (params: ShowWithRecordsParams) =>
  apiClient.get(`lists/${params.id}`, { params });
